"use client";

import React from "react";
import * as Sentry from "@sentry/nextjs";
import posthog from "posthog-js";

import { Button } from "@/components/ui/button";
import { ReportIssueFloatingCard } from "@/components/layout/report-issue";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  // Clear Sentry user context for public routes
  Sentry.setUser(null);
  Sentry.captureException(error);

  // Track error in PostHog
  posthog.captureException(error);
  posthog.capture("error_occurred", {
    error_name: error.name,
    error_message: error.message,
  });

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <h2 className="mb-5 text-center text-xl font-semibold">Ouch! Something went wrong!</h2>
      <Button type="button" variant="default" className="mb-6" onClick={() => reset()}>
        Try again
      </Button>
      <ReportIssueFloatingCard />
    </div>
  );
}
